export const PRODUCT_DESCRIPTION = 'PRODUCT_DESCRIPTION';
export const PRODUCT_DETAILS = 'PRODUCT_DETAILS';
export const TECHNICAL_DETAILS = 'TECHNICAL_DETAILS';
export const FAQ = 'FAQ';
export const ABOUT_BRAND = 'ABOUT_BRAND';
